// @generated by protoc-gen-es v2.2.0 with parameter "target=ts"
// @generated from file nike/clickstream/ux/commerce/cart/v2/item_clicked.proto (package nike.clickstream.ux.commerce.cart.v2, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_buf_validate_validate } from "../../../../../../buf/validate/validate_pb";
/**
 * Describes the file nike/clickstream/ux/commerce/cart/v2/item_clicked.proto.
 */
export const file_nike_clickstream_ux_commerce_cart_v2_item_clicked = /*@__PURE__*/ fileDesc("CjduaWtlL2NsaWNrc3RyZWFtL3V4L2NvbW1lcmNlL2NhcnQvdjIvaXRlbV9jbGlja2VkLnByb3RvEiRuaWtlLmNsaWNrc3RyZWFtLnV4LmNvbW1lcmNlLmNhcnQudjIiXAoLSXRlbUNsaWNrZWQSTQoEaXRlbRgBIAEoDjIzLm5pa2UuY2xpY2tzdHJlYW0udXguY29tbWVyY2UuY2FydC52Mi5DbGlja2FibGVJdGVtQgq6SAeCAQQQASAAKvoECg1DbGlja2FibGVJdGVtEh4KGkNMSUNLQUJMRV9JVEVNX1VOU1BFQ0lGSUVEEAASIwofQ0xJQ0tBQkxFX0lURU1fQVBQTEVfUEFZX0JVVFRPThAGEiIKHkNMSUNLQUJMRV9JVEVNX0NIRUNLT1VUX0JVVFRPThABEigKJENMSUNLQUJMRV9JVEVNX0dPX1RPX0NIRUNLT1VUX0JVVFRPThACEigKJENMSUNLQUJMRV9JVEVNX0dVRVNUX0NIRUNLT1VUX0JVVFRPThADEigKJENMSUNLQUJMRV9JVEVNX0tMQVJOQV9FWFBSRVNTX0JVVFRPThAPEikKJUNMSUNLQUJMRV9JVEVNX01FTUJFUl9DSEVDS09VVF9CVVRUT04QBBIgChxDTElDS0FCTEVfSVRFTV9QQVlQQUxfQlVUVE9OEAUSJgoiQ0xJQ0tBQkxFX0lURU1fRkFWT1JJVEVTX0pPSU5fTElOSxAHEicKI0NMSUNLQUJMRV9JVEVNX0ZBVk9SSVRFU19MT0dJTl9MSU5LEAgSJAogQ0xJQ0tBQkxFX0lURU1fU1VNTUFSWV9KT0lOX0xJTksQCRIlCiFDTElDS0FCTEVfSVRFTV9TVU1NQVJZX0xPR0lOX0xJTksQChIlCiFDTElDS0FCTEVfSVRFTV9TSVpFX1NFTEVDVE9SX0xJTksQCxIhCh1DTElDS0FCTEVfSVRFTV9QUk9NT19DT0RFX1RBQhAMEiQKIENMSUNLQUJMRV9JVEVNX1BST0RVQ1RfVEhVTUJOQUlMEA0SJwojQ0xJQ0tBQkxFX0lURU1fTkJZX0NVU1RPTUlaRV9CVVRUT04QDkLzAQooY29tLm5pa2UuY2xpY2tzdHJlYW0udXguY29tbWVyY2UuY2FydC52MkIQSXRlbUNsaWNrZWRQcm90b1ABogIFTkNVQ0OqAiROaWtlLkNsaWNrc3RyZWFtLlV4LkNvbW1lcmNlLkNhcnQuVjLKAiROaWtlXENsaWNrc3RyZWFtXFV4XENvbW1lcmNlXENhcnRcVjLiAjBOaWtlXENsaWNrc3RyZWFtXFV4XENvbW1lcmNlXENhcnRcVjJcR1BCTWV0YWRhdGHqAilOaWtlOjpDbGlja3N0cmVhbTo6VXg6OkNvbW1lcmNlOjpDYXJ0OjpWMmIGcHJvdG8z", [file_buf_validate_validate]);
/**
 * Describes the message nike.clickstream.ux.commerce.cart.v2.ItemClicked.
 * Use `create(ItemClickedSchema)` to create a new message.
 */
export const ItemClickedSchema = /*@__PURE__*/ messageDesc(file_nike_clickstream_ux_commerce_cart_v2_item_clicked, 0);
/**
 * Represents clickable items within the cart surface.
 *
 * @generated from enum nike.clickstream.ux.commerce.cart.v2.ClickableItem
 */
export var ClickableItem;
(function (ClickableItem) {
    /**
     * @generated from enum value: CLICKABLE_ITEM_UNSPECIFIED = 0;
     */
    ClickableItem[ClickableItem["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CLICKABLE_ITEM_APPLE_PAY_BUTTON = 6;
     */
    ClickableItem[ClickableItem["APPLE_PAY_BUTTON"] = 6] = "APPLE_PAY_BUTTON";
    /**
     * @generated from enum value: CLICKABLE_ITEM_CHECKOUT_BUTTON = 1;
     */
    ClickableItem[ClickableItem["CHECKOUT_BUTTON"] = 1] = "CHECKOUT_BUTTON";
    /**
     * @generated from enum value: CLICKABLE_ITEM_GO_TO_CHECKOUT_BUTTON = 2;
     */
    ClickableItem[ClickableItem["GO_TO_CHECKOUT_BUTTON"] = 2] = "GO_TO_CHECKOUT_BUTTON";
    /**
     * @generated from enum value: CLICKABLE_ITEM_GUEST_CHECKOUT_BUTTON = 3;
     */
    ClickableItem[ClickableItem["GUEST_CHECKOUT_BUTTON"] = 3] = "GUEST_CHECKOUT_BUTTON";
    /**
     * @generated from enum value: CLICKABLE_ITEM_KLARNA_EXPRESS_BUTTON = 15;
     */
    ClickableItem[ClickableItem["KLARNA_EXPRESS_BUTTON"] = 15] = "KLARNA_EXPRESS_BUTTON";
    /**
     * @generated from enum value: CLICKABLE_ITEM_MEMBER_CHECKOUT_BUTTON = 4;
     */
    ClickableItem[ClickableItem["MEMBER_CHECKOUT_BUTTON"] = 4] = "MEMBER_CHECKOUT_BUTTON";
    /**
     * @generated from enum value: CLICKABLE_ITEM_PAYPAL_BUTTON = 5;
     */
    ClickableItem[ClickableItem["PAYPAL_BUTTON"] = 5] = "PAYPAL_BUTTON";
    /**
     * Pair of links below the cart products under the "Favorites" section.
     *
     * @generated from enum value: CLICKABLE_ITEM_FAVORITES_JOIN_LINK = 7;
     */
    ClickableItem[ClickableItem["FAVORITES_JOIN_LINK"] = 7] = "FAVORITES_JOIN_LINK";
    /**
     * @generated from enum value: CLICKABLE_ITEM_FAVORITES_LOGIN_LINK = 8;
     */
    ClickableItem[ClickableItem["FAVORITES_LOGIN_LINK"] = 8] = "FAVORITES_LOGIN_LINK";
    /**
     * Pair of links below the cart summary section.
     *
     * @generated from enum value: CLICKABLE_ITEM_SUMMARY_JOIN_LINK = 9;
     */
    ClickableItem[ClickableItem["SUMMARY_JOIN_LINK"] = 9] = "SUMMARY_JOIN_LINK";
    /**
     * @generated from enum value: CLICKABLE_ITEM_SUMMARY_LOGIN_LINK = 10;
     */
    ClickableItem[ClickableItem["SUMMARY_LOGIN_LINK"] = 10] = "SUMMARY_LOGIN_LINK";
    /**
     * @generated from enum value: CLICKABLE_ITEM_SIZE_SELECTOR_LINK = 11;
     */
    ClickableItem[ClickableItem["SIZE_SELECTOR_LINK"] = 11] = "SIZE_SELECTOR_LINK";
    /**
     * @generated from enum value: CLICKABLE_ITEM_PROMO_CODE_TAB = 12;
     */
    ClickableItem[ClickableItem["PROMO_CODE_TAB"] = 12] = "PROMO_CODE_TAB";
    /**
     * @generated from enum value: CLICKABLE_ITEM_PRODUCT_THUMBNAIL = 13;
     */
    ClickableItem[ClickableItem["PRODUCT_THUMBNAIL"] = 13] = "PRODUCT_THUMBNAIL";
    /**
     * @generated from enum value: CLICKABLE_ITEM_NBY_CUSTOMIZE_BUTTON = 14;
     */
    ClickableItem[ClickableItem["NBY_CUSTOMIZE_BUTTON"] = 14] = "NBY_CUSTOMIZE_BUTTON";
})(ClickableItem || (ClickableItem = {}));
/**
 * Describes the enum nike.clickstream.ux.commerce.cart.v2.ClickableItem.
 */
export const ClickableItemSchema = /*@__PURE__*/ enumDesc(file_nike_clickstream_ux_commerce_cart_v2_item_clicked, 0);
